module.exports = __webpack_public_path__ + "img/remind.89ec3d70.png";